/* Dormelya Hushwake – lazy videos, scroll-to-offer buttons, sticky add to cart */
(function () {
  if (window.__hwInit) return;
  window.__hwInit = true;

  function findBuyTarget() {
    return (
      document.querySelector('product-info product-form') ||
      document.querySelector('product-form') ||
      document.querySelector('.product__info-container')
    );
  }

  function findAtcButton() {
    return (
      document.querySelector('product-info product-form button[type="submit"][name="add"]') ||
      document.querySelector('product-form button[type="submit"]')
    );
  }

  function scrollToBuy() {
    var target = findBuyTarget();
    if (!target) return;
    var info = target.closest ? target.closest('.product__info-container') : null;
    var offer = null;
    if (info) {
      /* Kaching bundles: first visible element (the outer wrapper comes before inner ones). */
      var found = info.querySelectorAll('[class*="kaching"], [id*="kaching"]');
      for (var i = 0; i < found.length; i++) {
        if (found[i].offsetHeight > 60) { offer = found[i]; break; }
      }
    }
    (offer || target).scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest ? event.target.closest('[data-hw-scroll-buy]') : null;
    if (!link) return;
    event.preventDefault();
    scrollToBuy();
  });

  function initVideos() {
    var videos = document.querySelectorAll('video[data-hw-src]');
    if (!videos.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function load(video) {
      if (!video.getAttribute('src')) video.setAttribute('src', video.getAttribute('data-hw-src'));
    }
    function play(video) {
      if (reduce) return;
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    }

    if (!('IntersectionObserver' in window)) {
      videos.forEach(function (v) { load(v); play(v); });
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var v = entry.target;
          if (entry.isIntersecting) {
            load(v);
            play(v);
          } else if (!v.paused) {
            v.pause();
          }
        });
      },
      { rootMargin: '200px 0px' }
    );
    videos.forEach(function (v) { observer.observe(v); });
  }

  function initSticky() {
    var bar = document.querySelector('[data-hw-sticky]');
    if (!bar || bar.__hwReady) return;
    bar.__hwReady = true;
    var footer = document.querySelector('.footer, footer');
    var button = bar.querySelector('[data-hw-sticky-btn]');
    var ticking = false;

    function watchEl() {
      var atc = findAtcButton();
      if (atc && atc.offsetHeight > 0) return atc;
      return findBuyTarget();
    }

    function check() {
      ticking = false;
      var el = watchEl();
      if (!el) return;
      /* Show only after the shopper has scrolled past the main button (button is above the viewport). */
      var passed = el.getBoundingClientRect().bottom < 0;
      var footerVisible = footer ? footer.getBoundingClientRect().top < window.innerHeight : false;
      var show = passed && !footerVisible;
      if (bar.classList.contains('is-visible') !== show) {
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        if (button) button.tabIndex = show ? 0 : -1;
      }
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(check);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);

    if (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        var atc = findAtcButton();
        if (bar.getAttribute('data-mode') === 'add' && atc && !atc.disabled) {
          atc.click();
        } else {
          scrollToBuy();
        }
      });
    }
    check();
  }

  function initCarousels() {
    var tracks = document.querySelectorAll('[data-hw-carousel]');
    Array.prototype.forEach.call(tracks, function (track) {
      if (track.__hwCarousel) return;
      track.__hwCarousel = true;
      var section = (track.closest && track.closest('.hw')) || track.parentElement;
      var nav = section ? section.querySelector('[data-hw-carousel-nav]') : null;
      if (!nav) return;
      var dots = nav.querySelectorAll('.hw-carousel-nav__dot');
      var count = nav.querySelector('[data-hw-carousel-count]');
      var prev = nav.querySelector('[data-dir="-1"]');
      var next = nav.querySelector('[data-dir="1"]');
      var items = track.children;
      var ticking = false;

      function step() {
        if (items.length < 2) return track.clientWidth || 1;
        return (items[1].offsetLeft - items[0].offsetLeft) || track.clientWidth || 1;
      }

      function update() {
        ticking = false;
        var i = Math.round(track.scrollLeft / step());
        if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 4) i = items.length - 1;
        i = Math.max(0, Math.min(items.length - 1, i));
        /* Progress: every step up to the current one is filled. */
        Array.prototype.forEach.call(dots, function (dot, k) { dot.classList.toggle('is-active', k <= i); });
        if (count) count.textContent = String(i + 1);
        if (prev) prev.disabled = i <= 0;
        if (next) next.disabled = i >= items.length - 1;
      }

      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      }, { passive: true });

      nav.addEventListener('click', function (event) {
        var button = event.target.closest ? event.target.closest('[data-dir]') : null;
        if (!button) return;
        track.scrollBy({ left: step() * parseInt(button.getAttribute('data-dir'), 10), behavior: 'smooth' });
      });

      update();
    });
  }

  function init() {
    initVideos();
    initSticky();
    initCarousels();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    initVideos();
    initCarousels();
  });
})();
